import React, { useContext } from "react";

import { BrandCartViewState } from "../BrandCart/BrandCartViewState";

interface IBrandPageCartStateContext {
  brandCartViewState: BrandCartViewState;
}

const DEFAULT_BRAND_CART_STATE: IBrandPageCartStateContext = {
  brandCartViewState: new BrandCartViewState("", async () => undefined),
};

export const BrandPageCartStateContext =
  React.createContext<IBrandPageCartStateContext>(DEFAULT_BRAND_CART_STATE);

export const useBrandPageCartStateContext = () => {
  const value = useContext(BrandPageCartStateContext);
  if (value === DEFAULT_BRAND_CART_STATE) {
    throw new Error(
      "useBrandPageCartStateContext must be used within a BrandPageCartStateContext.Provider"
    );
  }
  return value;
};
